import { useAppDispatch, useAppSelector } from "../redux/store";
import { updateHiddenSubheaders } from "../redux/slices/menu";

export const useSubheaderData = () => {
  const hiddenSubheaders = useAppSelector(
    (state) => state.menu.hiddenSubheaders
  );
  const dispatch = useAppDispatch();

  const toggleHidden = () => {
    dispatch(updateHiddenSubheaders(!hiddenSubheaders));
  };

  return {
    hiddenSubheaders,
    toggleHidden,
  };
};
